import paySimpleReducer from './reducers';

export * from './selectors';

export { default as paySimpleTypes } from './types';
export { default as paySimpleActions } from './actions';

export default paySimpleReducer;
